import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import axios from 'helpers/axios/axios';
import config from 'Config';
import { useSessionContext } from 'contexts/sessionProvider/SessionProvider';
import { useAuth0 } from '../Auth0/Auth0';
import { OrderItem, ProductData } from './types';
import { PRODUCT_MAPPING } from '../../constants';

type UseGetProductType = {
  productData: ProductData,
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

export const useGetModuleProduct = (isGetBaseProductSuccess: boolean, items: OrderItem[]): UseGetProductType => {
  const history = useHistory();
  const { isLoading: isAuth0Loading } = useAuth0();
  const { isInitialised, productId, useLegacy } = useSessionContext();
  const moduleProductId = (PRODUCT_MAPPING as any)[parseInt(productId, 10)];
  let presentmentUrl = `${config.API_PRODUCT_PRICE_ENDPOINT}?productId=${moduleProductId}`;
  if (useLegacy) {
    presentmentUrl += '&useLegacy=true';
  }

  const {
    isLoading: isProductDataLoading, isError, data, isSuccess
  } = useQuery(
    ['productData', moduleProductId],
    () => axios.get(presentmentUrl),
    {
      enabled:
        !isAuth0Loading &&
        isInitialised &&
        isGetBaseProductSuccess &&
        moduleProductId !== undefined,
      retry: false,
      staleTime: 1000 * 60 * 5 // 5 minutes
    }
  );

  if (isError) {
    history.push('/error');
  }
  const isLoading = !isInitialised || isProductDataLoading || isAuth0Loading;

  const productData = data?.data || {} as ProductData;
  return {
    productData, isLoading, isError, isSuccess
  };
};
